import { appMatchesConnectRequest } from "./appMatchesConnectRequest";
import { domainSearchToken } from "./urlDomain";

// The single strict-match-then-URL-fallback recipe shared by discovery
// (listAvailableApps, server) and the picker (ConnectorPrompt, client): a
// urlPattern describes where credentials inject, which for API and MCP
// connectors rarely covers the product URLs users paste, so when the strict
// match comes up empty fall back to the URL's domain name — flagged, since the
// fallback is a suggestion, not a URL match. Candidates must already be
// draft- and availability-filtered; this only decides which of them match the
// request.
export function matchAvailableApps<
  T extends { urlPattern: string; identifier: string; name: string },
>(
  candidates: T[],
  { search, targetUrl }: { search?: string | null; targetUrl?: string | null }
): { matched: T[]; urlFallback: boolean } {
  const matched = candidates.filter(
    (app) =>
      !(search || targetUrl) ||
      appMatchesConnectRequest(app, { search, targetUrl })
  );
  if (matched.length > 0 || !targetUrl) return { matched, urlFallback: false };

  const token = search || domainSearchToken(targetUrl);
  if (!token) return { matched, urlFallback: false };
  const fallback = candidates.filter((app) =>
    appMatchesConnectRequest(app, { search: token })
  );
  return { matched: fallback, urlFallback: fallback.length > 0 };
}
